import LandingPageLayout from 'components/LandingPageLayout';
import AllInclucive from 'components/LandingPageAllInclucive';

import AmenitiesWellington from 'components/LandingPageAmenitiesLiberty/AmenitiesWellington';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import Neighbourhood from '../components/LandingPageNeighbourhood/Neighbourhood';
import RoomTypesTwo from '../components/LandingPageRoomTypesTwo';
// import TitleLargeFive from '../components/LandingPageTitleSection/TitleLargeFive';
import React from 'react';
import TwoBedrooms from 'components/LandingPageTwoBedrooms';
import Configuration from 'components/LandingPageConfiguration';
import RoomsSliderCentered from 'components/LandingPageCarousels/RoomsSlider/centered';
import Head from 'next/head';
import FeaturesSliderUptoFive from 'components/LandingPageCarousels/FeaturesSlider/FeatureSliderUptoFive';
import TitleSectionThree from 'components/LandingPageTitleSection/TitleSectionThree';
// import Cookies from 'universal-cookie';
// import { v4 as uuidv4 } from 'uuid';
// import { JotformApi } from 'services/integration/jotform';

const WinnipegSoulrooms = () => {
  // const cookies = new Cookies();
  // let count = 0;
  // cookies.set('jotformUUID', uuidv4(), { path: '/', expires: new Date(Date.now() + 3600000) });
  // setInterval(() => cookies.set('proactive', (count += 1), { path: '/' }), 1000);

  const data = {
    roomSlider: [
      {
        src: '/static/images/landingPages/s1.png',
      },
      {
        src: '/static/images/landingPages/s2.png',
      },
      {
        src: '/static/images/landingPages/SingleSupreme.png',
      },
      {
        src: '/static/images/landingPages/s3.png',
      },
      {
        src: '/static/images/landingPages/s5.png',
      },
      {
        src: '/static/images/landingPages/s6.png',
      },
      {
        src: '/static/images/landingPages/s7.jpeg',
      },
      {
        src: '/static/images/landingPages/s4.png',
      },
    ],
    featuresSlider: [
      {
        src: 'static/images/landingPages/homeslider1.jpg',
      },
      {
        src: 'static/images/landingPages/homeslider3.jpg',
      },

      {
        src: 'static/images/landingPages/homeslider5.jpg',
      },
      {
        src: 'static/images/landingPages/homeslider7.png',
      },
    ],
  };
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Featured location - Pembina highway</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/winnipeg-soulrooms" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Featured location - Pembina highway" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="If you study at the University of Manitoba, this is a place to be!" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta name="description" content="If you study at the University of Manitoba, this is a place to be!" />
        <link rel="canonical" href="https://www.soulrooms.com/winnipeg-soulrooms" />
      </Head>
      <LandingPageLayout>
        {/* <WelcomeModal show={true}  /> */}
        {/* <TitleLargeFive
          title="THANKS FOR YOUR INTEREST IN WINNIPEG SOULROOMS, HERE ARE A FEW EXCLUSIVE OPTIONS FOR YOU:"
          wide={true}
        /> */}
        <AllInclucive
          img={
            <iframe
              width={'101%'}
              height={395}
              src="https://www.youtube.com/embed/KK3-kL2sC7U"
              title="YouTube video player"
              frameBorder={0}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen></iframe>
          }
          title={'WINNIPEG SOULROOMS @ ARC'}
          description={
            <p
              className="lh-base fs-4 responsiveText pt-lg-4 pt-md-3 pt-4 "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Winnipeg SoulRooms is conveniently located minutes away from the entrance to The University of Manitoba. A
              brand new building with state-of-the-art facilities that are bound to entertain students and professionals
              alike. With grocery stores and restaurants, a short walk away, these smart homes redefine convenience.
            </p>
          }
          btn={true}
          btnTitle="Find Properties in this location"
          href="/find-a-soulroom"
        />
        {/* FEATURE SLIDER  */}
        {/* <FeaturesSliderUptoFive heading="PRICES ARE INCLUSIVE OF" imageSource={data.featuresSlider} /> */}
        {/* ROOM TYPES SECTION  */}
        <RoomTypesTwo
          title="SINGLE BEDROOM CONFIGURATIONS"
          heading="For those who like to kick back alone."
          bgcolor="black"
          img="static/images/landingPages/premiumroom.png"
          price="$1200/Month"
          p1="Full XL bed with floating nightstand"
          p2="4 drawer dresser and desk"
          p3="Smart TV and streaming capabilities"
          regularImg="static/images/landingPages/supreme.png"
          regularPrice="$1225/Month"
          regularP1="Full XL bed with floating nightstand"
          regularP2="4 drawer dresser and desk"
          regularP3="Smart TV and streaming capabilities"
          enSuitImg="static/images/landingPages/accesible.png"
          enSuitPrice="$1220/Month"
          enSuitP1="Full XL bed with floating nightstand"
          enSuitP2="4 drawer dresser and desk"
          enSuitP3="Smart TV and streaming capabilities"
          titleOne="Premium"
          titleTwo="Supreme"
          titleThree="Accessible"
          href1="#"
          href2="#"
          href3="#"
          hrefExt="https://s3.amazonaws.com/uforis.tours.krpano/processed/1/98b11ffc-8de6-4358-bd8b-00e090a37edb/WebTour/tour.html"
          btnTxt="TOUR A PREMIUM SINGLE NOW"
        />
        {/* <TitleSectionOne
          title="MORE THAN JUST A GREAT PLACE TO STAY!"
          btnTxt="Book a single bedroom"
          bg="white"
          href="https://www.realsage.com/properties"
        /> */}
        <TitleSectionThree
          title="MORE THAN JUST A GREAT PLACE TO STAY!"
          btnTxt="Book a single bedroom"
          // bg="white"
          href="https://www.realsage.com/properties"
        />
        <TwoBedrooms
          title="TWO BEDROOM CONFIGURATIONS"
          heading="It takes two to Tango!"
          bgcolor="black"
          img="static/images/landingPages/2BedSupreme.jpeg"
          imgTwo="static/images/landingPages/2BedPremium.jpeg"
          imgThree="static/images/landingPages/2BedSuite.jpeg"
          imgFour="static/images/landingPages/2BedDeluxe.jpeg"
          price="$975/month"
          p1="Full XL bed with floating nightstand"
          p2="4 drawer dresser and desk"
          p3="Smart TV and streaming capabilities"
          enSuitPrice="$885/Month"
          enSuitP1="Full XL bed with floating nightstand"
          enSuitP2="4 drawer dresser and desk"
          enSuitP3="Smart TV and streaming capabilities"
          enSuitP4="Loveseat with coffee table"
          titleOne="2-Bed Supreme"
          titleTwo="2-bed Premium"
          titleThree="2-bed Suite"
          titleFour="2-Bed Deluxe"
          priceThree="$855/month"
          priceFour="$950/month"
          pThree="Loveseat with coffee table"
          pFour="Loveseat with coffee table"
          hrefExt="https://s3.amazonaws.com/uforis.tours.krpano/processed/1/3e0770f3-50a6-4c1b-b965-d9c311a22d8a/WebTour/tour.html"
          btnTxt="TOUR A PREMIUM TWO BED NOW"
        />
        {/* <TitleSectionOne
          title="AT SOULROOMS, SHARING IS SMART SAVING"
          btnTxt="Book your SoulRoom"
          bg="white"
          href="https://www.realsage.com/properties"
        /> */}
        <TitleSectionThree
          title="AT SOULROOMS, SHARING IS SMART SAVING"
          btnTxt="Book your SoulRoom"
          //  bg="f"
          href="https://www.realsage.com/properties"
        />
        <Configuration
          img={<img src="static/images/landingPages/configurations.png" alt="" className="img img-fluid w-full" />}
          title={'$920/month'}
          description={
            <p
              className="card-text  fs-res-24-18 pb-md-4 pt-md-2"
              style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
              <p className="my-1">Full XL bed with floating nightstand</p>
              <p className="my-1">4 drawer dresser and desk</p>
              <p className="my-1">Smart TV and streaming capabilities</p>
              <p className="my-1">Loveseat with coffee table</p>
            </p>
          }
          hrefExt="https://s3.amazonaws.com/uforis.tours.krpano/processed/1/04fceb3a-a368-4089-97c4-773f58e7de6e/WebTour/tour.html"
          btnTxt="TOUR A FOUR BED SUITE NOW"
        />
        {/* ROOMS SLIDER  */}{' '}
        <RoomsSliderCentered imageSource={data.roomSlider} title="FLOOR PLANS AND FURNITURE LIST" />
        {/* AMENITIES SECTION  */}
        <AmenitiesWellington
          title="WHAT DO YOU GET?"
          title1="Multiple Lounges"
          title2="Common Kitchen"
          title3="Fitness Center"
          title4="Business Center"
          bg1="/static/images/landingPages/multiple.png"
          bg2="/static/images/landingPages/common.png"
          bg3="/static/images/landingPages/fitness.png"
          bg4="/static/images/landingPages/business.png"
        />
        {/* <TitleSectionOne
          title="ABOUT TIME YOU MAKE A GOOD DECISION"
          btnTxt="Book a SoulRoom"
          bg="white"
          href="https://www.realsage.com/properties"
        /> */}
        <TitleSectionThree
          title="ABOUT TIME YOU MAKE A GOOD DECISION"
          btnTxt="Book a SoulRoom"
          bg="white"
          href="https://www.realsage.com/properties"
        />
        {/* Neighbourhood section  */}
        <Neighbourhood
          title="Neighbourhood Highlights"
          img1="/static/images/landingPages/tea.png"
          img2="/static/images/landingPages/club.png"
          img3="/static/images/landingPages/pizza.png"
          cardTitle="Panda Tea"
          cardSubTitle="$"
          details="Perfect for those on the go as well as the
           ones who wish to take slow sips and forget the world momentarily. "
          cardTitle2="The Good Will Social Club"
          cardSubTitle2="$$"
          details2="Noted as being one of the best brewpubs in town, this
           watering hole not only serves great brews but also has live music to go with it. "
          cardTitle3="Fast fired Pizza"
          cardSubTitle3="$$"
          details3="Located 15 minutes away from Winnipeg SoulRooms, this outlet
           is a local favorite. Open late into the night, but pizza is
            just at good for breakfast."
        />
      </LandingPageLayout>
    </div>
  );
};

export default WinnipegSoulrooms;
